var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DataCard',{attrs:{"no-padding":"","title":"Filer"}},[_c('div',{staticClass:"scrollable"},[_c('file-explorer',{attrs:{"rootPath":"global","showUpdated":true,"userHasPriviledge":this.$parent.isAdmin}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }